export enum CartSortVariansEnum {
  BY_ADDING = 'По добавлению',
  BY_ALPHABETICALLY = 'По алфавиту',
  BY_MAX_PRICE = 'Сначала дешёвые',
  BY_MIN_PRICE = 'Сначала дорогие',
}

export enum PromocodeSource {
  Input,
  Url,
}

export enum AllowPointsAndPromo {
  All = 0,
  Promocode = 1,
  Points = 2,
}

export enum CartItemCategoryEnum {
  Available = 'available',
  Unavailable = 'unavailable',
  NoDeliveryToSelectedAddress = 'noDeliveryToSelectedAddress',
  UnavailableEdo = 'unavailableEdo',
  Privileges = 'privileges',
  UnavailableBeer = 'unavailableBeer',
}

export enum CART_ERROR_CODES {
  OUT_OF_STOCK = 'M',
  ADDRESS_WITHOUT_EGAIS = 'EGAIS',
  EDO = 'EDO',
  PEU_B = 'PEU_B',
}

export enum AnalyticsPageCollection {
  basket = 'basket',
  sidebar = 'sidebar_hits',
}

export enum CartPageView {
  Basket = 'basket',
  Checkout = 'checkout',
}
